import SuperAdminDashboardApi from "./SuperAdminDashboardApi";

const SuperAdminDashboardService = async (): Promise<any> => {
 try {
    const res = await SuperAdminDashboardApi()
      return res;
 } catch (error) {
    throw error;
 }
};
export default SuperAdminDashboardService;
